import { createFeature, createSelector } from '@ngrx/store';
import { AppState } from '../app.state';
import { iRuleTypesState } from '@app/Shared/interfaces/iRuleTypes';
import { ruleTypesReducer } from '../reducers/rule-type.reducer';

export const ruleTypesFeature = createFeature({
    name: 'ruleTypes',
    reducer: ruleTypesReducer,
});

const selectRuleTypesState = (state: AppState) => state.ruleTypes;

export const { name: ruleTypesFeatureKey, reducer: ruleTypesFeatureReducer } = ruleTypesFeature;

// Selectors
export const selectRuleTypes = createSelector(selectRuleTypesState, (state: iRuleTypesState) => state.ruleTypes);

export const selectSelectedRuleType = createSelector(selectRuleTypesState, (state: iRuleTypesState) => state.selectedRuleType);

export const selectRuleTypesLoading = createSelector(selectRuleTypesState, (state: iRuleTypesState) => state.isLoading);

export const selectRuleTypesError = createSelector(selectRuleTypesState, (state: iRuleTypesState) => state.error);

export const ruleTypesFeatureSelectors = {
    ...ruleTypesFeature,
    selectRuleTypes,
    selectSelectedRuleType,
    selectRuleTypesLoading,
    selectRuleTypesError,
};

export const {
    selectRuleTypes: ruleTypesFeatureSelectRuleTypes,
    selectSelectedRuleType: ruleTypesFeatureSelectSelectedRuleType,
    selectRuleTypesLoading: ruleTypesFeatureSelectRuleTypesLoading,
    selectRuleTypesError: ruleTypesFeatureSelectRuleTypesError,
} = ruleTypesFeatureSelectors;
